import { render, staticRenderFns } from "./ApplicantFormStep4.vue?vue&type=template&id=2a4a0b44&scoped=true"
import script from "./ApplicantFormStep4.vue?vue&type=script&lang=js"
export * from "./ApplicantFormStep4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a0b44",
  null
  
)

export default component.exports